import styled from 'styled-components';
import { Typography } from '../../../typography';

const ModalContent = styled.div`
	display: flex;
	height: 100%;
	padding: 0 30px;
	flex-direction: column;
`;

const TeamMembers = styled.div`
	overflow-y: auto;
	&::-webkit-scrollbar {
		display: none;
	}
`;

const Title = styled(Typography)`
	font-size: 30px;
`;

const Close = styled.button`
	background-color: transparent;
	position: absolute;
	top: 12px;
	right: 15px;
`;

// eslint-disable-next-line import/no-anonymous-default-export
export default {
	ModalContent,
	TeamMembers,
	Title,
	Close,
};
